import { Value } from '@/lib/constants';
import { IListingItem } from '@/modules/core/types';
import { NEXT_API_URL } from 'environment';

import { SearchRequestObject } from '../elasticsearch/models';

export const similarSearchElasticApi = async (
  searchRequest: Value<SearchRequestObject>,
): Promise<[IListingItem[], number]> => {
  const r: [IListingItem[], number] = await fetch(
    `${NEXT_API_URL}/marketplace/similar-search-api`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        searchRequest

      }),
    }
  ).then((res) => res.json());

  return r;
};
